import { AdapterFactory } from '../AdapterFactory';

export const authService = AdapterFactory.getAuthAdapter();
